import PropTypes from "prop-types";
import { Column as DevextremeColumn } from "devextreme-react/data-grid";

export default function Column(props) {
  return <DevextremeColumn {...props} />;
}

Object.assign(Column, DevextremeColumn);

Column.defaultProps = {
  minWidth: 50,
};

Column.propTypes = {
  minWidth: PropTypes.number,
  dataType: PropTypes.string,
};
